import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { NeedAClassSection } from '../components/NeedAClassSection';
import { InsideSystemSection } from '../components/InsideSystemSection';
import { LibrarySection } from '../components/LibrarySection';
import { BonusesSection } from '../components/BonusesSection';
import { TransformationSection } from '../components/TransformationSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
export function Landing() {
  return <div className="w-full bg-ivory" data-id="element-278" data-mp="29s9glix9sz8">
      <Hero data-id="element-279" data-mp="2ati6jcgu3ds" />
      <main data-id="element-280" data-mp="2blczry8nx30">
        <ProblemSection data-id="element-281" data-mp="27xmz2s05st1" />
        <SolutionSection data-id="element-282" data-mp="3tgl75feib9z0" />
        <NeedAClassSection data-id="element-283" data-mp="3tg1xelz0frw2" />
        <InsideSystemSection data-id="element-284" data-mp="3tes2g5ngeztn" />
        <LibrarySection data-id="element-285" data-mp="3peq7efc854nc" />
        <BonusesSection data-id="element-286" data-mp="3pe85p36sly81" />
        <TransformationSection data-id="element-287" data-mp="3pfj7wyklaxx1" />
        <TestimonialsSection data-id="element-288" data-mp="3pguc2zhy67oo" />
        <OfferSection data-id="element-289" data-mp="3kg6kocpt3otx" />
        <GuaranteeSection data-id="element-290" data-mp="3kgoopvipn7ce" />
        <FaqSection data-id="element-291" data-mp="3khhlq4rvaihc" />
        <FinalCtaSection data-id="element-292" data-mp="3khzprnkru0zt" />
      </main>
      <Footer data-id="element-293" data-mp="l0rtr9fh2em6" />
      <PurchaseNotifications data-id="element-294" data-mp="kz8bjda99thr" />
    </div>;
}